module.exports = __webpack_public_path__ + "media/icons/favourite-off@3x-a10be659.svg";